import useSWR from 'swr';
import type { EmbeddedProduct } from 'modules/supplier/products';
import type { FilterState } from './types';

export function useProducts(
  { type, kind, search, provider }: FilterState,
  outlet_or_service_category: number | undefined,
): EmbeddedProduct[] {
  const queryParams: Record<string, unknown> = {
    type,
    kind,
    search,
    disabled: false,
    outlet_or_service_category,
  };
  if (provider) {
    queryParams['provider'] = provider.id;
  } else {
    queryParams['provided'] = true;
  }
  const { data } = useSWR<EmbeddedProduct[], unknown>(
    {
      url: 'supplier/products/',
      method: 'GET',
      queryParams,
    },
    { suspense: true, keepPreviousData: true },
  );

  return data!;
}
